import styled from '@emotion/styled'

export const StyleGridItems = styled.div<any>`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyleGridItem = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 15px 20px;
  align-items: center;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    padding: 10px 14px;
  }
`

export const StyleGridIconWrapper = styled.div<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary']};
  height: 100px;
  width: 100px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    height: 80px;
    width: 80px;
    border-radius: 999px;
  }

  @media (max-width: 768px) {
    height: 60px;
    width: 60px;
    border-radius: 999px;
  }

  @media (max-width: 480px) {
    height: 50px;
    width: 50px;
    border-radius: 999px;
  }
`

export const StyleGridTitle = styled.p`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.black500};

  @media (max-width: 1024px) {
    font-size: 13px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
    font-size: 11px;
  }
`

export const StyleActionWrapper = styled.div`
  align-self: flex-start;
`

export const StyleGridRow = styled.div<any>`
  display: flex;
  align-items: center;
  width: 100%;

  ${(props: any) => props?.customStyle}
`
